export default __webpack_public_path__ + "static/media/Vdo_1.d6b58c79.mp4";